import http from "@/utils/http";
import httpApi from "@/apis/httpApi";
export const getPageOfBar=(data)=>{
    return http.get({
        url:httpApi.selfClient.getPageOfBar,
        data
    })
}
export const getPageOfClient=({num,size,client})=>{
    return http.get({
        url:httpApi.selfClient.getPageOfClient,
        data:{
            num,
            size,client
        }
    })
}
export const getPageOfDevice=({num,size,device})=>{
    return http.get({
        url:httpApi.selfClient.getPageOfDevice,
        data:{
            num,
            size,device
        }
    })
}
export const getPageOfSoft=({num,size,soft})=>{
    return http.get({
        url:httpApi.selfClient.getPageOfSoft,
        data:{
            num,
            size,soft
        }
    })
}
export const switchBarLog=(data)=>{
  return http.get({
      url:httpApi.debugModel.switchBarLog,
      data
  })
}
export const delBar=({ids})=>{
  return http.get({
      url:httpApi.debugModel.delBar,
      data:{
          ids
      }
  })
}
export const updateBarName=(data)=>{
  return http.post({
      url:httpApi.debugModel.updateBarName,
      json:data
  })
}

export const switchClientDebug=(data)=>{
  return http.get({
      url:httpApi.debugModel.switchClientDebug,
      data
  })
}
export const delClient=(data)=>{
  return http.get({
      url:httpApi.debugModel.delClient,
      data
  })
}
export const restartClient=(data)=>{
  return http.get({
      url:httpApi.debugModel.restartClient,
      data
  })
}
export const getDebugCfgByBarId=(data)=>{
  return http.get({
      url:httpApi.debugModel.getDebugCfgByBarId,
      data
  })
}